import { TooltipPosition } from "../TooltipContent.types";

export const isTopOrBottomPosition = (position: TooltipPosition) =>
  position === TooltipPosition.Top ||
  position === TooltipPosition.TopStart ||
  position === TooltipPosition.TopEnd ||
  position === TooltipPosition.Bottom ||
  position === TooltipPosition.BottomStart ||
  position === TooltipPosition.BottomEnd;
